import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import apiClient from '@/api/client';

const Register = () => {
    const navigate = useNavigate();
    const [values,setValues] = useState({
        name : '',
        email:'',
        password : ''
});

const [errors, setErrors] = useState({
  name: '',
  email: '',
  password: '',
});

const validateForm = () => {
  let formErrors = {};
  let valid = true;

  if (!values.name) {
    formErrors.name = 'Name is required';
    valid = false;
  }

  if (!values.email) {
    formErrors.email = 'Email is required';
    valid = false;
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    formErrors.email = 'Email is not valid';
    valid = false;
  }

  if (!values.password) {
    formErrors.password = 'Password is required';
    valid = false;
  } else if (values.password.length < 6) {
    formErrors.password = 'Password must be at least 6 characters';
    valid = false;
  }

  setErrors(formErrors);
  return valid;
};

const handleSubmit = async (e) => {
  e.preventDefault();
  if (validateForm()) {
    try {
      const response = await apiClient.post('/register', values);
      console.log('Registration successful:', response.data);
      alert('Registration successful! Please login.');
      navigate('/');
    } catch (error) {
      const message = error.response?.data?.message || 'Registration failed. Please try again.';
      alert(message);
      console.error(error);
    }
  }
};
  


const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  

  return (
    <div className='text-center login-page'>
        <form onSubmit={handleSubmit}>
        <div className="mt-6">Register Page</div>
        <div className="form-item mt-5">
          <input type="text" id="name" name="name" onChange={handleInputChange}/>
          {errors.name && <div style={{ color: 'red' }}>{errors.name}</div>}
          <br />
          <label htmlFor="name">User Name</label>
        </div>
        <div className="form-item mt-5">
          <input type="text" id="email" name="email" onChange={handleInputChange}/>
          {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}
          <br />
          <label htmlFor="email">Email Address</label>
        </div>
        <div className="form-item mt-5">
          <input type="password" id="password" name="password" onChange={handleInputChange}/>
          {errors.password && <div style={{ color: 'red' }}>{errors.password}</div>}
          <br />
          <label htmlFor="password">Password</label>
        </div>
        <div className='mt-5'>
        <Link to="/">Login</Link>
        </div>
        <button type='submit' className='loginButton'>Register</button>
        </form>
    </div>
  )
}

export default Register